import AbstractDataHandler from "../shared/AbstractDataHandler";
import { getBaseUrl, getPlanSlug } from "../shared/utils";

export default class DataHandler extends AbstractDataHandler {
    getData() {
        this.spinner.showFullscreen();
        let uri = `${getBaseUrl(this.p)}/${getPlanSlug(this.p)}/data`;
        this.executeGetRequest(
            uri,
            data => this.loadData(data)
        );
    }
}
